import isHash from "validator/lib/isHash";
import { z } from "zod/v4";

const IDR_GRAPH_REVISION_ALGORITHM = "sha256";

function isCanonicalIdrGraphRevision(value: string): boolean {
  const [algorithm, digest, ...extra] = value.split(":");
  if (
    algorithm !== IDR_GRAPH_REVISION_ALGORITHM ||
    digest === undefined ||
    extra.length > 0
  ) {
    return false;
  }
  return digest === digest.toLowerCase() && isHash(digest, "sha256");
}

export const IdrGraphRevisionSchema = z
  .string()
  .refine(
    isCanonicalIdrGraphRevision,
    "must be a sha256-prefixed lowercase digest",
  )
  .brand<"IdrGraphRevision">();

export type IdrGraphRevision = z.infer<typeof IdrGraphRevisionSchema>;
